import { MatFormFieldAppearance } from '@angular/material/form-field';
import { EnumHint } from '../entity/enum/enum-hint';
import { SelectedArea } from './area-select.component';

export class GeneralComponent {
    public hintNumber: string;
    public hintDate: string;
    public hintHour: string;
    public hintCalc: string;
    public hintSeparator: string;
    public hintScoreBoard: string;
    public hintKg: string;
    public hintHourResult: string;
    public hintContrSecEx: string;
    public hintSecCamEx: string;
    public hintLoteRw?: string;
    public hintSafra?: string;
    public hintSafraPreBasica?: string;
    public hintLoteDs?: string;
    public hintLoteDsPet?: string;
    public hintLoteOrigem?: string;
    public hintSiloDestino?: string;
    public hintSiteCdr?: string;
    public hintCalcTipoTrat?: string;
    public hintSafraLabel?: string;
    public hintSafraPreBasicaLabel?: string;
    public hintRecobrRolos?: string;
    public hintLinhaDescarga?: string;
    public hintList?: string;
    public step: string;
    public collapseCard?: boolean;
    public required: string;
    public iconEnableField: string;
    public iconDisableField: string;
    public formFieldAppearance: string;
    public formFieldFloatLabel: string;
    public iconBarCodeField: string;
    public hintControle: string;
    public regexDate: string;
    public regexHour: string;
    public regexSafra: string;
    public regexSafraBasica: string;
    public regexSafraPreBasica: string;
    public regexLoteRw: string;
    public regexCerar: string;
    public regexLoteCs: string;
    public hintLoteTb: string;
    public areaSelect: SelectedArea = Number(localStorage.getItem('area-select-number'));
    public regexLoteRwPet: string;
    public regexNewLoteRW: string;
    constructor(step?: string, collapseCard?: boolean) {
        this.step = step;
        this.collapseCard = collapseCard;
        this.setInitValues();
        this.setHintValues();
        this.setRegexValues();
    }

    get isComercial() {
        return this.areaSelect === SelectedArea.Comercial
    }

    get isBasica() {
        return this.areaSelect === SelectedArea.Basica
    }

    get isPreBasica() {
        return this.areaSelect === SelectedArea.PreBasica
    }

    private setRegexValues(): void {
        this.regexDate = '\^((0[1-9]|[12][0-9]|3[01])[/]?(0[1-9]|1[0-2])[/]?[12][0-9]{3})';
        this.regexHour = '\^([0-1]{1}[0-9]{1}|[2][0-3]{1})[:]?([0-5]{1}[0-9]{1})';
        this.regexSafra = '\^[A-Z]{2}[0-9]{2}';
        this.regexSafraPreBasica = '\^[A-Z]{3}[0-9]{2}';
        this.regexSafraBasica = '\^[A-Z]{3}[0-9]{2}';
        this.regexLoteRw = '\[a-zA-Z]{2}[0-9]{7}';
        this.regexCerar = '\[0-9]{4}[-][0-9]{7}[-][0-9]{4}';//Validators.pattern('\^[A-z]{3}[/20][0-9]{4}
        this.regexLoteCs = '\\w{10}';
        this.regexLoteRwPet = '\^([a-zA-Z]{6}[0-9]{4})$|([a-zA-Z]{6}[0-9]{4}[;]{1})+([a-zA-Z]{6}[0-9]{4}[;]?)|([a-zA-Z]{1}[0-9]{1}[a-zA-Z]{3}[0-9]{4})|([A-Z][0-9][A-Z]{5}[0-9]{3})';
        this.regexNewLoteRW = '[E][0-9][a-zA-Z]?GRAO[0-9]{3}';
    }

    private setInitValues(): void {
        this.required = '*';
        this.iconEnableField = '';
        this.iconDisableField = 'fa fa-lock iconMenu';
        this.formFieldAppearance = 'outline';
        this.formFieldFloatLabel = 'always';
        this.iconBarCodeField = 'fa fa-barcode fa-1x btnIcon';
    }

    private setHintValues(): void {
        this.hintNumber = this.getHintMap(EnumHint.Numbers);
        this.hintDate = this.getHintMap(EnumHint.Date);
        this.hintHour = this.getHintMap(EnumHint.Hour);
        this.hintCalc = this.getHintMap(EnumHint.Calc);
        this.hintSeparator = this.getHintMap(EnumHint.Separator);
        this.hintScoreBoard = this.getHintMap(EnumHint.ScoreBoard);
        this.hintKg = this.getHintMap(EnumHint.Kg);
        this.hintHourResult = this.getHintMap(EnumHint.HourResult);
        this.hintContrSecEx = this.getHintMap(EnumHint.ControleSecagemExemplo);
        this.hintSecCamEx = this.getHintMap(EnumHint.SecadorCamaraExemplo);
        this.hintLoteRw = this.getHintMap(EnumHint.LoteRw);
        this.hintSafra = this.getHintMap(EnumHint.Safra);
        this.hintSafraPreBasica = this.getHintMap(EnumHint.SafraPreBasica)
        this.hintLoteDs = this.getHintMap(EnumHint.LoteDs);
        this.hintLoteOrigem = this.getHintMap(EnumHint.LoteDs);
        this.hintSiloDestino = this.getHintMap(EnumHint.SiloDestino);
        this.hintSiteCdr = this.getHintMap(EnumHint.SiteCdr);
        this.hintCalcTipoTrat = this.getHintMap(EnumHint.CalcTipoTrat);
        this.hintSafraLabel = this.getHintMap(EnumHint.SafraLabel);
        this.hintSafraPreBasicaLabel = this.getHintMap(EnumHint.SafraPreBasicaLabel);
        this.hintRecobrRolos = this.getHintMap(EnumHint.RecobrRolos);
        this.hintLinhaDescarga = this.getHintMap(EnumHint.LinhaDescarga);
        this.hintList = this.getHintMap(EnumHint.DropDownList);
        this.hintControle = this.getHintMap(EnumHint.ControlesGerados);
        this.hintLoteTb = this.getHintMap(EnumHint.loteTb);
        this.hintLoteDsPet = this.getHintMap(EnumHint.LoteDsPet);
    }

    private getHintMap(option?: EnumHint): string {
        const hintMap = new Map<EnumHint, string>();
        hintMap.set(EnumHint.Numbers, 'Somente números são aceitos');
        hintMap.set(EnumHint.Date, 'Formato (dd/mm/yyyy) é aceito');
        hintMap.set(EnumHint.Hour, 'Formato (hh:mm) é aceito');
        hintMap.set(EnumHint.Calc, 'Campo automatico');
        hintMap.set(EnumHint.Separator, 'Em caso de mais de uma informação separar por ;');
        hintMap.set(EnumHint.ScoreBoard, 'Formato Padrão ABC1234 ou Formato Mercosul ABC1B34');
        hintMap.set(EnumHint.HourResult, '(Horas)');
        hintMap.set(EnumHint.Kg, '(Kg)');
        hintMap.set(EnumHint.ControleSecagemExemplo, 'Exemplo: 123');
        hintMap.set(EnumHint.SecadorCamaraExemplo, 'Formato D ou G ou C + numero do secador.camara(2 caracteres)');
        hintMap.set(EnumHint.LoteRw, 'Formato Padrão 2 Letras e 7 algarismos');
        hintMap.set(EnumHint.Safra, 'Formato IN ou VE + 2 algarismos');
        hintMap.set(EnumHint.SafraPreBasica, 'Formato INV ou VER + 2 algarismos');
        hintMap.set(EnumHint.LoteDs, 'Formato Padrão 6 Letras e 4 algarismos ou 4 Letras e 5 algarismos para BÁSICA');
        hintMap.set(EnumHint.LoteDsPet, 'Formato Padrão 6 Letras e 4 algarismos ou Padrão 4 Letras e 5 Algarismos para Pré-Básica');
        hintMap.set(EnumHint.LoteOrigem, 'Formato Padrão 6 Letras e 4 algarismos');
        hintMap.set(EnumHint.SiloDestino, 'Formato Padrão SB + Nº Silo (2 caracteres) ou BB para BÁSICA');
        hintMap.set(EnumHint.SiteCdr, 'Campo de preenchimento do site recebimento CDR ou PTU-Básica');
        hintMap.set(EnumHint.CalcTipoTrat, 'O campo é calculado a partir do preenchimento do campo tipo de tratamento');
        hintMap.set(EnumHint.SafraLabel, 'Safra - Exemplo: IN21 ou VE21');
        hintMap.set(EnumHint.SafraPreBasicaLabel, 'Safra - Exemplo: INV21 ou VER21');
        hintMap.set(EnumHint.RecobrRolos, 'Somente números 0 a 100, e apenas com final 0 ou 5');
        hintMap.set(EnumHint.LinhaDescarga, 'Somente numero de 1 a 4 é aceito');
        hintMap.set(EnumHint.DropDownList, 'Somente as opções da lista são aceitas');
        hintMap.set(EnumHint.ControlesGerados, 'Controle Gerado automático ao Salvar o registro');
        hintMap.set(EnumHint.loteTb, 'A informação será atualizada automaticamente a partir dos lançamentos da ET004');
        return hintMap.get((option));
    }


}
